import { z } from 'zod';

/**
 * Thread node - represents subsequent messages in an email thread
 * Always a child of an Activity node via HAS_THREAD edge
 */
export const ThreadPropsSchema = z.object({
  message_id: z.string().min(1, 'Message ID is required'),
  thread_id: z.string().min(1, 'Thread ID is required'),
  subject: z.string(),
  body_html: z.string().optional(),
  sent_at: z.string().datetime(),
  from_email: z.string().email(),
  to_emails: z.array(z.string().email()),
  cc_emails: z.array(z.string().email()).optional(),
  bcc_emails: z.array(z.string().email()).optional(),
  source: z.literal('gmail'),
  source_id: z.string(),
});

export type ThreadProps = z.infer<typeof ThreadPropsSchema>;
